/**
 * Zuletzt angezeigte Reihenfolge der Meldungsliste (Hans 14.10.2026) — für
 * „vorige / nächste Meldung" im schwebenden Rand der Meldungsseite.
 * sessionStorage: gilt für diesen Tab und überlebt ein Neuladen.
 */

const SCHLUESSEL = "testerwerk:meldungs-reihenfolge"

export function reihenfolgeMerken(ids: number[]): void {
  try {
    sessionStorage.setItem(SCHLUESSEL, JSON.stringify(ids))
  } catch {
    /* Speicher gesperrt — dann eben ohne Navigation */
  }
}

/** Nachbarn der Meldung in der zuletzt angezeigten Liste: [vorige, nächste] */
export function reihenfolgeNachbarn(id: number): [number | null, number | null] {
  try {
    const ids = JSON.parse(sessionStorage.getItem(SCHLUESSEL) ?? "[]") as number[]
    const i = ids.indexOf(id)
    if (i < 0) return [null, null]
    return [i > 0 ? ids[i - 1] : null, i < ids.length - 1 ? ids[i + 1] : null]
  } catch {
    return [null, null]
  }
}
